import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import './index.css'
import { useNavigate, useParams } from "react-router-dom";
import { useAppConfig } from "../../hooks/useAppConfig";
import { useCategory } from "../../hooks/useCategory";
import { CategoryType } from "../../contexts/CategoryContext";
import { useState } from "react";
import 'animate.css'
import LazyImage from '../LazyImage/LazyImage';
import styles from './styles.module.css'



type CategoryItemProps = {
    category: CategoryType;
    legendColor: string;
    noShadow: boolean;
    showName?: boolean;
}


type CategoryItemProps_V2 = {
    category: CategoryType[];
    legendColor: string;
    noShadow: boolean;
    showName: boolean;
}

export function CategoryItem({ category, legendColor, noShadow }: CategoryItemProps) {
    const navigate = useNavigate();
    const { pluginspace_id } = useParams();
    const { getAppConfig } = useAppConfig();
    const [loadingImage, setLoadingImage] = useState(true);
    const categories = [category];

    const goTo = async () => {
        const config = await getAppConfig();
        if (config && config.content && config.content.pdv && config.content.pdv.agroupCategory) {
            navigate(`/${pluginspace_id}/pdv/${category.id}`)
        } else {
            navigate(`/${pluginspace_id}/subcategory/${category.id}`)
        }
    }

    return (
        <Carousel
            showThumbs={false}
            showStatus={false}
            showIndicators={false}
        >
            {categories.map(() =>
                <div className="item" key={category.id} onClick={async () => await goTo()}>
                    {noShadow ? <></> : <div className="overlay"></div>}
                    <img style={loadingImage ? { visibility: 'hidden' } : {}} src={category.img} className="img-carousel" onLoad={() => setLoadingImage(false)} />
                     <p className="legend-category" style={{ color: legendColor }}>{category.name}</p>
                </div>)
            }
        </Carousel>
    );
}


/*Novos componentes abaixo */

export function CategoryListAtacado({ category, legendColor, noShadow, showName }: CategoryItemProps_V2) {
    return (
        <div className={styles.category_container}>
            {category.map((item: any, index: number) => (
                <CategoryItemAtacado
                    key={item.id}
                    category={item}
                    legendColor={legendColor}
                    noShadow={noShadow}
                    showName={showName}
                    animationDelay={index * 100} // Delay para cada item
                />
            ))}
        </div>
    );
}

export function CategoryItemAtacado({ category, showName, noShadow }: CategoryItemProps & { animationDelay: number }) {
    const navigate = useNavigate();
    const { pluginspace_id } = useParams();
    const { getAppConfig } = useAppConfig();
    const { getCategoriesAll, getChildrenCategories } = useCategory();



    const goTo = async (id_categorie:number) => {
        const config = await getAppConfig();
        if (config && config.content && config.content.pdv && config.content.pdv.agroupCategory) {
            navigate(`/${pluginspace_id}/pdv/${id_categorie}`)
        } else {
            navigate(`/${pluginspace_id}/subcategory/${id_categorie}`)
        }
    }

    return (
        <div
            className={`${styles.container} animate__animated animate__fadeInUp`}
            // Aplica o delay
            onClick={async () => await goTo(category.id)}>
            {noShadow && <div className={'overlay'}></div>}
            <LazyImage
                src={category.img}
                alt={category.name}
                className={styles.image_container}
            />
            {showName && <span className={styles.nome_categoria}>{category.name}</span>}
        </div>
    );
}